/// <amd-module name="Analytics/Common/RestClient/Analytics" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   analytics\client\webapi\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Analytics from "Analytics/Common/Contracts/Analytics";

export interface IAnalyticsRestClient extends IVssRestClient {
    /**
     * Returns the estimated space requirements for enabling Analytics in MiB.
     * 
     */
    getSpaceRequirements(): Promise<number>;
    /**
     * Gets the current state of the Analytics feature.
     * 
     */
    getState(): Promise<Analytics.AnalyticsStateDetails>;
    /**
     * Sets the state of the Analytics feature.
     * 
     * @param state - The state to transition to. Only Enabled, Disabled and Paused can be manually transitioned to.
     */
    updateState(state: Analytics.AnalyticsState): Promise<void>;
}

class AnalyticsRestClient extends RestClientBase implements IAnalyticsRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Returns the estimated space requirements for enabling Analytics in MiB.
     * 
     */
    public async getSpaceRequirements(
        ): Promise<number> {

        return this.beginRequest<number>({
            apiVersion: "4.1-preview.1",
            routeTemplate: "_apis/Analytics/SpaceRequirements"
        });
    }

    /**
     * Gets the current state of the Analytics feature.
     * 
     */
    public async getState(
        ): Promise<Analytics.AnalyticsStateDetails> {

        return this.beginRequest<Analytics.AnalyticsStateDetails>({
            apiVersion: "4.1-preview.1",
            routeTemplate: "_apis/Analytics/State/{state}"
        });
    }

    /**
     * Sets the state of the Analytics feature.
     * 
     * @param state - The state to transition to. Only Enabled, Disabled and Paused can be manually transitioned to.
     */
    public async updateState(
        state: Analytics.AnalyticsState
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "4.1-preview.1",
            method: "PATCH",
            routeTemplate: "_apis/Analytics/State/{state}",
            routeValues: {
                state: state
            }
        });
    }

}

export const AnalyticsClientName = "IAnalyticsRestClient";

export function getAnalyticsClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IAnalyticsRestClient {
    return pageContext.getRestClient<IAnalyticsRestClient>(AnalyticsClientName, options);
}

RestClients.add(AnalyticsClientName, { 
    factory: AnalyticsRestClient,
    options: {
        serviceInstanceType: "0000003c-0000-8888-8000-000000000000"
    }
});
